/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlDetail extends models.ComplianceControlBase {
    getFixupPrototypeFunction() { return ComplianceControlDetail.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlDetail>): ComplianceControlDetail {
        let obj = Object.assign(new ComplianceControlDetail(), model);
        ComplianceControlDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlDetail>): ComplianceControlDetail {
        if (!model) return null;
        return ComplianceControlDetail.newInstance(<ComplianceControlDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlDetail) {
        if (!obj) return;

        models.ComplianceControlDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlDetail): boolean {
        if (models.ComplianceControlBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceControlDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Unique ID for the control
     */
    compliance_control_id: string;

    /**
     * Unique URI for the control
     */
    compliance_control_uri: string;

    /**
     * Tenant ID associated with the control
     */
    tenant_id: string;

    /**
     * Unique URI of the parent compliance standard
     */
    compliance_standard_uri: string;

    /**
     * Name of the control
     */
    control_name: string;

    /**
     * Description of the control
     */
    control_description: string;

    /**
     * Family of the control
     */
    control_family: string;

    /**
     * Sub family of the control
     */
    control_sub_family: string;

    /**
     * Severity values
     */
    severity: models.Severity;

    /**
     * Creation timestamp
     */
    created_at: Date;

    /**
     * Last update timestamp
     */
    updated_at: Date;

    /**
     * Creator of the control
     */
    created_by: string;

    /**
     * Last updater of the control
     */
    updated_by: string;

}
